import fetchWrapper from './fetchWrapper';

export default {
  getMetadata() {
    return fetchWrapper('/activity/metadata', {
      method: 'GET',
    }).then((resp) => resp.json());
  },

  saveFilter({ groupId, payload }) {
    return fetchWrapper(`/activity/filters/${groupId}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }).then((resp) => resp.json());
  },

  testNotification({ groupId, body, type }) {
    const url = `/activity/testNotification/${groupId}`;
    return fetchWrapper(url, {
      method: 'POST',
      body: JSON.stringify({
        ...body,
        _t: type,
      }),
    }).then((resp) => resp.json());
  },

  testExistingNotification({ groupId, alertConfigId, notificationId, body, type }) {
    const url = `/activity/testNotification/${groupId}/${alertConfigId}/${notificationId}`;
    return fetchWrapper(url, {
      method: 'POST',
      body: JSON.stringify({
        ...body,
        _t: type,
      }),
    }).then((resp) => resp.json());
  },

  loadClusters({ groupId }) {
    return fetchWrapper(`/activity/clusters/${groupId}`, {
      method: 'GET',
    }).then((resp) => resp.json());
  },
};
